// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Layout_pageWrapper__aFr5h","contentContainer":"Layout_contentContainer__7VJJ5"};